import { render, staticRenderFns } from "./ViewLabourerPage.vue?vue&type=template&id=b68c0574&scoped=true&"
import script from "./ViewLabourerPage.vue?vue&type=script&lang=js&"
export * from "./ViewLabourerPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewLabourerPage.vue?vue&type=style&index=0&id=b68c0574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c0574",
  null
  
)

export default component.exports